"use strict";

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _excluded = ["clerk"],
  _excluded2 = ["clerk"],
  _excluded3 = ["clerk"],
  _excluded4 = ["clerk"],
  _excluded5 = ["clerk"],
  _excluded6 = ["clerk"],
  _excluded7 = ["clerk"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var uiComponents_exports = {};
__export(uiComponents_exports, {
  CreateOrganization: function CreateOrganization() {
    return _CreateOrganization;
  },
  OrganizationProfile: function OrganizationProfile() {
    return _OrganizationProfile;
  },
  OrganizationSwitcher: function OrganizationSwitcher() {
    return _OrganizationSwitcher;
  },
  SignIn: function SignIn() {
    return _SignIn;
  },
  SignUp: function SignUp() {
    return _SignUp;
  },
  UserButton: function UserButton() {
    return _UserButton;
  },
  UserProfile: function UserProfile() {
    return _UserProfile;
  }
});
module.exports = __toCommonJS(uiComponents_exports);
var import_react = __toESM(require("react"));
var import_withClerk = require("./withClerk");
var Portal = /*#__PURE__*/function (_import_react$default) {
  _inherits(Portal, _import_react$default);
  var _super = _createSuper(Portal);
  function Portal() {
    var _this;
    _classCallCheck(this, Portal);
    _this = _super.apply(this, arguments);
    _this.portalRef = import_react.default.createRef();
    return _this;
  }
  _createClass(Portal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.props.appearance !== this.props.props.appearance) {
        this.props.updateProps({
          node: this.portalRef.current,
          props: this.props.props
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.portalRef.current) {
        this.props.mount(this.portalRef.current, this.props.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.portalRef.current) {
        this.props.unmount(this.portalRef.current);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */import_react.default.createElement("div", {
        ref: this.portalRef
      });
    }
  }]);
  return Portal;
}(import_react.default.PureComponent);
var _SignIn = (0, import_withClerk.withClerk)(function (_ref) {
  var clerk = _ref.clerk,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */import_react.default.createElement(Portal, {
    mount: clerk.mountSignIn,
    unmount: clerk.unmountSignIn,
    updateProps: clerk.__unstable__updateProps,
    props: props
  });
}, "SignIn");
var _SignUp = (0, import_withClerk.withClerk)(function (_ref2) {
  var clerk = _ref2.clerk,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /* @__PURE__ */import_react.default.createElement(Portal, {
    mount: clerk.mountSignUp,
    unmount: clerk.unmountSignUp,
    updateProps: clerk.__unstable__updateProps,
    props: props
  });
}, "SignUp");
var _UserProfile = (0, import_withClerk.withClerk)(function (_ref3) {
  var clerk = _ref3.clerk,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /* @__PURE__ */import_react.default.createElement(Portal, {
    mount: clerk.mountUserProfile,
    unmount: clerk.unmountUserProfile,
    updateProps: clerk.__unstable__updateProps,
    props: props
  });
}, "UserProfile");
var _UserButton = (0, import_withClerk.withClerk)(function (_ref4) {
  var clerk = _ref4.clerk,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /* @__PURE__ */import_react.default.createElement(Portal, {
    mount: clerk.mountUserButton,
    unmount: clerk.unmountUserButton,
    updateProps: clerk.__unstable__updateProps,
    props: props
  });
}, "UserButton");
var _OrganizationProfile = (0, import_withClerk.withClerk)(function (_ref5) {
  var clerk = _ref5.clerk,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /* @__PURE__ */import_react.default.createElement(Portal, {
    mount: clerk.mountOrganizationProfile,
    unmount: clerk.unmountOrganizationProfile,
    updateProps: clerk.__unstable__updateProps,
    props: props
  });
}, "OrganizationProfile");
var _CreateOrganization = (0, import_withClerk.withClerk)(function (_ref6) {
  var clerk = _ref6.clerk,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /* @__PURE__ */import_react.default.createElement(Portal, {
    mount: clerk.mountCreateOrganization,
    unmount: clerk.unmountCreateOrganization,
    updateProps: clerk.__unstable__updateProps,
    props: props
  });
}, "CreateOrganization");
var _OrganizationSwitcher = (0, import_withClerk.withClerk)(function (_ref7) {
  var clerk = _ref7.clerk,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /* @__PURE__ */import_react.default.createElement(Portal, {
    mount: clerk.mountOrganizationSwitcher,
    unmount: clerk.unmountOrganizationSwitcher,
    updateProps: clerk.__unstable__updateProps,
    props: props
  });
}, "OrganizationSwitcher");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CreateOrganization: _CreateOrganization,
  OrganizationProfile: _OrganizationProfile,
  OrganizationSwitcher: _OrganizationSwitcher,
  SignIn: _SignIn,
  SignUp: _SignUp,
  UserButton: _UserButton,
  UserProfile: _UserProfile
});